if (!customElements.get('collection-quick-add-quantity')) {
  class CollectionQuickAddQuantity extends HTMLElement {
    static cartPromise;

    static getCart() {
      if (!this.cartPromise) {
        const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
        this.cartPromise = fetch(cartUrl, {
          headers: { Accept: 'application/json' },
        }).then((response) => {
          if (!response.ok) throw new Error('Winkelwagen kon niet worden geladen.');
          return response.json();
        });
      }

      return this.cartPromise;
    }

    connectedCallback() {
      this.variantId = Number(this.dataset.variantId);
      this.quantityElement = this.querySelector('[data-quick-add-quantity]');
      this.valueElement = this.querySelector('[data-quantity-value]');
      this.minusButton = this.querySelector('[data-quantity-minus]');
      this.plusButton = this.querySelector('[data-quantity-plus]');
      this.quantity = 0;

      if (!this.variantId || !this.quantityElement || !this.valueElement) return;

      this.minusHandler = () => this.changeQuantity(this.quantity - 1);
      this.plusHandler = () => this.changeQuantity(this.quantity + 1);
      this.minusButton?.addEventListener('click', this.minusHandler);
      this.plusButton?.addEventListener('click', this.plusHandler);

      if (window.FoxTheme?.pubsub?.subscribe && window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
        this.cartUpdateUnsubscriber = window.FoxTheme.pubsub.subscribe(
          window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (event?.cart?.items) {
              CollectionQuickAddQuantity.cartPromise = Promise.resolve(event.cart);
              this.sync(event.cart);
            }
          }
        );
      }

      CollectionQuickAddQuantity.getCart()
        .then((cart) => this.sync(cart))
        .catch(() => {});
    }

    disconnectedCallback() {
      this.minusButton?.removeEventListener('click', this.minusHandler);
      this.plusButton?.removeEventListener('click', this.plusHandler);
      this.cartUpdateUnsubscriber?.();
    }

    sync(cart) {
      this.quantity = (cart.items || [])
        .filter((item) => Number(item.variant_id) === this.variantId)
        .reduce((total, item) => total + Number(item.quantity || 0), 0);

      this.valueElement.textContent = String(this.quantity);
      this.classList.toggle('is-in-cart', this.quantity > 0);
      this.quantityElement.hidden = this.quantity < 1;
    }

    async changeQuantity(quantity) {
      const nextQuantity = Math.max(0, quantity);
      this.setAttribute('aria-busy', 'true');

      try {
        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', {
            bubbles: true,
            detail: { sections },
          })
        );

        const changeUrl = window.FoxTheme?.routes?.cart_change_url || `${window.Shopify?.routes?.root || '/'}cart/change.js`;
        const response = await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: String(this.variantId),
            quantity: nextQuantity,
            sections,
            sections_url: window.location.pathname,
          }),
        });

        const cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || 'Aantal kon niet worden aangepast.');

        CollectionQuickAddQuantity.cartPromise = Promise.resolve(cart);
        this.sync(cart);

        if (window.FoxTheme?.pubsub?.publish && window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
          window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart,
            target: this,
          });
        }
      } catch (error) {
        console.error(error);
        CollectionQuickAddQuantity.cartPromise = undefined;
        CollectionQuickAddQuantity.getCart()
          .then((cart) => this.sync(cart))
          .catch(() => {});
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('collection-quick-add-quantity', CollectionQuickAddQuantity);
}
